import React, { FunctionComponent } from "react";

import NavBarRedesignDestination from "./nav_bar_redesign_destination";
import PageNames from "../../../models/domain/enums/page_names";
import { NavRouteContext } from "./nav_bar_redesign_route";
import { RedesignNavItem } from "./nav_bar_redesign_options";

export type Props = {
  destinations: RedesignNavItem[]
  pageName: PageNames
  routeContext: NavRouteContext
};

const NavBarRedesignDestinations: FunctionComponent<Props> = ({ destinations, pageName, routeContext }) => {
  return <nav className="NavBarRedesign-destinations" aria-label="Primary">
    {destinations.map((item) => <NavBarRedesignDestination
      key={item.key}
      item={item}
      active={item.base.pageNames.has(pageName)}
      routeContext={routeContext}
    />)}
  </nav>;
};

export default NavBarRedesignDestinations;
